module.exports = __webpack_public_path__ + "img/park-bg02.9d61df51.png";